module.exports = __webpack_public_path__ + "img/people.9f7a0f16.svg";